/* eslint-disable react/jsx-pascal-case */
import React from 'react'
import PropTypes from 'prop-types'
import { ReactComponent as SvgComponent } from './svg/Alert.svg'

export default function Icon__Alert({ width, height, className, style }) {
  const props = { width, height, className, style }
  return <SvgComponent {...props} />
}

Icon__Alert.displayName = 'Icon__Alert'

Icon__Alert.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
}

Icon__Alert.defaultProps = {
  width: 18,
  height: 18,
}
